import { COMMON_PERMISSIONS, composePermissions } from '@/commons/permissoesGrupos';

import solicitacoesRoutes from "@/modules/projeto/routes/solicitacoes";

export default [
    // Projetos
    {
        path: '/projetos',
        name: 'listaProjetos',
        component: () => import('@/modules/projeto/views/listas/ListaProjetosView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('GESTAO', 'PROJETO', 'COORDENADOR')], isRotaOrigem: true },
    },

    // Solicitações em Ajuste
    {
        path: '/solicitacoesemajuste',
        name: 'solicitacoesEmAjuste',
        component: () => import('@/modules/projeto/views/listas/ListaSolicitacoesEmAjusteView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('COORDENADOR')] },
    },

    // Contratos a Vencer
    {
        path: '/contratoavencer',
        name: 'contratosAVencer',
        component: () => import('@/modules/projeto/views/listas/ContratosAVencerView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('GESTAO', 'PROJETO', 'COORDENADOR')] },
    },

    // Cadastro de Projeto
    {
        path: '/cadastrarprojeto',
        name: 'cadastrarProjeto',
        component: () => import('@/modules/projeto/views/cadastros/CadastroProjetoView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('PROJETO')] },
        props: true
    },

    // Cadastro de Projetos por Instrumento Jurídico
    {
        path: '/cadastrarprojeto/:ijid',
        name: 'criarProjetoPorInstrumentoJuridico',
        component: () => import('@/modules/projeto/views/cadastros/CadastroProjetoView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('COMPRAS', 'PROJETO')] },
        props: true
    },

    // Edição de Projeto
    {
        path: '/projetos/:id/editar',
        name: 'edicaoProjeto',
        component: () => import('@/modules/projeto/views/cadastros/EdicaoProjetoView.vue'),
        meta: { requiresAuth: true },
        props: true
    },

    // Histórico de alterações de um aditivo do projeto
    {
        path: '/projetos/aditivos/:id/historico',
        name: 'historicoAditivo',
        component: () => import('@/modules/projeto/views/listas/HistoricoAditivoView.vue'),
        meta: { requiresAuth: true },
        props: (route) => ({ id: route.params.id, numero: route.query.numero }),
    },

    // Detalhe de Projeto
    {
        path: '/projetos/:id',
        name: 'detalheProjeto',
        component: () => import('@/modules/projeto/views/detalhes/DetalheProjetoView.vue'),
        meta: { requiresAuth: true, temFilhas: true },
        redirect: { name: 'dados' },
        props: true,
        children: [
            {
                path: '/projetos/:id/dashboard',
                name: 'dashboard',
                component: () => import('@/modules/projeto/components/tab/DashboardProjetoTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: '/projetos/:id/dados',
                name: 'dados',
                component: () => import('@/modules/projeto/components/tab/DadosProjetoTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: '/projetos/:id/rubricas',
                name: 'rubricas',
                component: () => import('@/modules/projeto/components/tab/RubricasTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: '/projetos/:id/metas',
                name: 'metas',
                component: () => import('@/modules/projeto/components/tab/MetaTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: '/projetos/:id/desembolsos',
                name: 'desembolsos',
                component: () => import('@/modules/projeto/components/tab/DesembolsoTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: '/projetos/:id/rendimentos',
                name: 'rendimentos',
                component: () => import('@/modules/projeto/components/tab/RendimentosContaBancariaTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: '/projetos/:id/membros',
                name: 'membros',
                component: () => import('@/modules/projeto/components/tab/MembroTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            {
                path: '/projetos/:id/solicitacoes',
                name: 'solicitacoes',
                component: () => import('@/modules/projeto/components/tab/SolicitacaoTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            },
            // Rascunhos, reservas de veículos e relatórios de solicitação agora são
            // sub-listas da aba de Solicitações. As rotas antigas seguem válidas e
            // redirecionam para a sub-lista correspondente.
            {
                path: '/projetos/:id/rascunhos',
                redirect: (to) => ({ name: 'solicitacoes', params: { id: to.params.id }, query: { lista: 'rascunhos' } }),
            },
            {
                path: '/projetos/:id/relatoriosdesolicitacao',
                redirect: (to) => ({ name: 'solicitacoes', params: { id: to.params.id }, query: { lista: 'relatorios' } }),
            },
            {
                path: '/projetos/:id/reservasveiculos',
                redirect: (to) => ({ name: 'solicitacoes', params: { id: to.params.id }, query: { lista: 'reservas' } }),
            },
            {
                path: '/projetos/:id/termos',
                name: 'termos',
                component: () => import('@/modules/projeto/components/tab/TermoTab.vue'),
                meta: { requiresAuth: true },
                props: true,
            }
        ]
    },
    // Lista de Relatórios de Projetos
    {
        path: '/relatoriosdeprojetos',
        name: 'listaRelatoriosProjetos',
        component: () => import('@/modules/projeto/views/listas/ListaRelatoriosProjetosView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('GESTAO', 'PROJETO', 'COORDENADOR')] },
    },

    // Cadastro de Coordenador de Projeto
    {
        path: '/projeto/:id/cadastrocoordenador',
        name: 'cadastroCoordenador',
        component: () => import('@/modules/projeto/views/cadastros/CadastroCoordenadorView.vue'),
        meta: { requiresAuth: true, allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('COMPRAS', 'GESTAO', 'PROJETO')] },
        props: true
    },

    // Lista de apoiadas  
    {
        path: '/apoiadas',
        name: 'apoiadas',
        component: () => import('@/modules/projeto/views/listas/ListaApoiadasView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('GESTAO')],

        },
    },
    
    // Lista de Desembolsos de Projetos
    {
        path: '/desembolsos',
        name: 'listaDesembolsos',
        component: () => import('@/modules/projeto/views/listas/ListaDesembolsosView.vue'),
        meta: { requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('CONTABILIDADE', 'ORDENADOR', 'GESTAO')],
         },
    },

    // Detalhe de membro
    {
        path: '/membro/:id',
        name: 'detalheMembro',
        component: () => import('@/modules/projeto/views/detalhes/DetalheMembroView.vue'),
        meta: { requiresAuth: true },
        props: true
    },

    // Cadastro de Membro
    {
        path: '/projeto/:id/cadastromembro/',
        name: 'cadastroMembro',
        component: () => import('@/modules/projeto/views/cadastros/CadastroMembroView.vue'),
        meta: { requiresAuth: true },
        props: true
    },

    // Edição de Membro
    {
        path: '/edicaomembro/:id/membro',
        name: 'edicaoMembro',
        component: () => import('@/modules/projeto/views/cadastros/CadastroMembroView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    {
        path: '/listatermos',
        name: 'listaTermos',
        component: () => import('@/modules/projeto/views/listas/ListaTermosView.vue'),
        meta: { requiresAuth: true},
    },
    // Solicitações Gerais
    ...solicitacoesRoutes,
]
